import $ from 'jquery'

export const mountToggleHeaderButtonHandler = (buttonId, toggleCb) => {
	const searchId = '#' + buttonId;
	$(document).on('click', 'header', null, (evt) => {
		if ($(evt.target).closest(searchId).length) {
			toggleCb();
		}
	});
};